import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import MainContent from "../components/MainContent";
import ProcessSection from "../components/Process";
import ServicesSection from "../components/Services";
import RealResults from "../components/RealResults";
import PricingPlans from "../components/PricingPlans";
import TrustedBy from "../components/TrustedBy";
import Footer from "../components/footer";

function Home() {
  const { pathname, hash, state } = useLocation();

  useEffect(() => {
    const stateTarget = state && typeof state === "object" ? state.scrollTarget : "";
    const storedTarget = sessionStorage.getItem("qc_scroll_target");
    const hashTarget = hash?.replace("#", "");
    const targetId = stateTarget || storedTarget || hashTarget;

    if (!targetId) return;

    if (storedTarget) {
      sessionStorage.removeItem("qc_scroll_target");
    }

    let intervalId = 0;
    let attempts = 0;
    const maxAttempts = 35;

    const applyHashScroll = () => {
      attempts += 1;

      const el = document.getElementById(targetId);
      if (!el) {
        if (attempts >= maxAttempts) clearInterval(intervalId);
        return;
      }

      const header = document.querySelector(".nv");
      const headerH = header ? header.offsetHeight : 0;

      // Use native element scrolling to support whichever element is the active scroll container.
      el.scrollIntoView({ behavior: "auto", block: "start", inline: "nearest" });
      if (headerH > 0) {
        window.scrollBy({ top: -(headerH + 8), left: 0, behavior: "auto" });
      }

      const aligned = Math.abs(el.getBoundingClientRect().top - (headerH + 8)) < 6;
      if (aligned || attempts >= maxAttempts) {
        clearInterval(intervalId);
      }
    };

    applyHashScroll();
    intervalId = window.setInterval(applyHashScroll, 90);

    return () => window.clearInterval(intervalId);
  }, [pathname, hash, state]);

  return (
    <>
     
      {/* HERO */}
      <section id="top" className="section">
        <div className="container">
          <MainContent />
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" className="section">
        <div className="container">
          <ServicesSection />
        </div>
      </section>

      {/* PROCESS */}
      <section id="process" className="section">
        <div className="container">
          <ProcessSection />
        </div>
      </section>

      {/* RESULTS */}
      <section id="results" className="section">
        <div className="container">
          <RealResults />
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="section">
        <div className="container">
          <PricingPlans />
        </div>
      </section>

      {/* TRUSTED */}
      <section id="trusted" className="section">
        <div className="container">
          <TrustedBy />
        </div>
      </section>

      {/* FAQ + CONTACT */}
       <section className="section">
        <div className="container">
          <Footer />
        </div>
      </section>
    </>
  );
}

export default Home;
